<template>
  <!-- <v-row justify="center"> -->
    <v-snackbar
      :value="value"
      @input="e => $emit('input', e)"
      :bottom="position === 'bottom'"
      :color="color"
      :left="position === 'left'"
      :right="position === 'right'"
      :timeout="timeout"
      :multi-line="this.lines.length > 1"
      absolute
      :top="position === 'top'"
    >
      <lu-vbox>
        <span v-for='(line, idx) in lines' :key='"line" + idx'>{{ line }}</span>
      </lu-vbox>
      <template v-slot:action="{ attrs }">
        <v-btn
          icon
          v-bind="attrs"
          @click="$emit('input', false)"
        >
          <close-icon/>
        </v-btn>
      </template>
    </v-snackbar>
  <!-- </v-row> -->
</template>

<script>
import { VSnackbar, VBtn } from 'vuetify/lib'
import CloseIcon from 'vue-material-design-icons/Close.vue'
export default {
  name: 'snackbar',
  components: { VSnackbar, VBtn, CloseIcon },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: false,
      default: 'info'
    },
    position: {
      type: String,
      required: false,
      default: 'top'
    },
    timeout: {
      type: Number,
      required: false,
      default: 1500
    }
  },
  computed: {
    lines () {
      return this.text.split('\n')
    }
  },
  data () {
    return {
      displayed: this.value
    }
  },
  methods: {
    cancel () {
      this.$emit('input', this.displayed)
      this.$emit('confirmEvt', false)
    },
    confirm () {
      this.$emit('input', this.displayed)
      this.$emit('confirmEvt', true)
    }
  }
}
</script>
